let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ap0LY")).then(() => parcelRequire('IpO3b'));